import { useQuery, gql } from "@apollo/client";
import { OrderAddressFragment } from "../../portal/hooks/useClientAddresses";
import CheckoutCartFragment from "../fragments/CheckoutCartFragment";

const CartQuery = gql`
  query cart {
    me {
      _id
      currentClient {
        _id
        name
        isPrivateCustomer
        isNewCustomer
        isInstitution
        defaultShippingType
        defaultShippingOption
        prescriber {
          contactNumber
          contactName
          contactEmail
        }
        lastOrderAddress {
          ...OrderAddressFragment
        }
        orderAddresses {
          ...OrderAddressFragment
        }
        cart {
          ...CheckoutCartFragment
        }
        doctors {
          contactNumber
          contactName
          contactEmail
        }
      }
    }
  }
  ${OrderAddressFragment}
  ${CheckoutCartFragment}
`;

const useCart = () => {
  const { loading, error, data, refetch } = useQuery(CartQuery);

  const currentClient = data?.me?.currentClient;
  const cart = currentClient?.cart;

  return {
    loading,
    refetch,
    error,
    cart,
    currentClient,
  };
};

export default useCart;
